import styled from 'styled-components';

export const ManagerRegistrationPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ManagerRegistrationPageInnerWrapper = styled.div`
  max-width: 840px;
  width: 100%;
`;
